if (!customElements.get('wlsn-youtube-video')) {
  class WLSNYouTubeVideo extends HTMLElement {
    static instances = [];
    static ytApiReady = false;
    static ytApiLoading = false;
    static ytApiCallbacks = [];

    constructor() {
      super();
      this.youtubeId = this.dataset.youtubeId;
      this.player = null;
      this.isInitialized = false;
      this.isPlaying = false;
      this.handlePlayClick = this.handlePlayClick.bind(this);
      this.handleYTStateChange = this.handleYTStateChange.bind(this);
      WLSNYouTubeVideo.instances.push(this);
    }

    connectedCallback() {
      this.elements = {
        trigger: this.querySelector('.js-wlsn-youtube-video-trigger'),
        iframe: this.querySelector('.js-wlsn-youtube-video-iframe')
      };
      this.elements.trigger?.addEventListener('click', this.handlePlayClick);
      // Lazy players are created on first click only (many iframes crash iOS Safari)
      if (this.hasAttribute('data-lazy')) return;
      if (window.YT && window.YT.Player) {
        this.initYouTubePlayer();
      } else {
        WLSNYouTubeVideo.loadYTApi(() => this.initYouTubePlayer());
      }
    }

    disconnectedCallback() {
      this.elements?.trigger?.removeEventListener('click', this.handlePlayClick);
      WLSNYouTubeVideo.instances = WLSNYouTubeVideo.instances.filter(inst => inst !== this);
    }

    static loadYTApi(cb) {
      if (WLSNYouTubeVideo.ytApiReady) {
        cb();
        return;
      }
      WLSNYouTubeVideo.ytApiCallbacks.push(cb);
      if (!WLSNYouTubeVideo.ytApiLoading) {
        WLSNYouTubeVideo.ytApiLoading = true;
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
        window.onYouTubeIframeAPIReady = () => {
          WLSNYouTubeVideo.ytApiReady = true;
          WLSNYouTubeVideo.ytApiCallbacks.forEach(fn => fn());
          WLSNYouTubeVideo.ytApiCallbacks = [];
        };
      }
    }

    handlePlayClick() {
      // Pause all other videos
      WLSNYouTubeVideo.instances.forEach(inst => {
        if (inst !== this && inst.isPlaying) inst.pause();
      });
      this.classList.add('active');
      if (!this.isInitialized) {
        WLSNYouTubeVideo.loadYTApi(() => this.initYouTubePlayer(true));
      } else {
        this.play();
      }
    }

    initYouTubePlayer(autoplay = false) {
      if (this.isInitialized || this.player || !window.YT || !window.YT.Player) return;
      this.player = new YT.Player(this.elements.iframe, {
        videoId: this.youtubeId,
        playerVars: {
          autoplay: autoplay ? 1 : 0,
          controls: 1,
          rel: 0,
          showinfo: 0,
          modestbranding: 1,
          playsinline: 1
        },
        events: {
          onReady: () => {
            this.isInitialized = true;
            if (autoplay) this.play();
          },
          onStateChange: this.handleYTStateChange
        }
      });
    }

    handleYTStateChange(event) {
      if (event.data === YT.PlayerState.PLAYING || event.data === YT.PlayerState.PAUSED) {
        this.isPlaying = (event.data === YT.PlayerState.PLAYING);
        this.classList.add('active');
      } else if (event.data === YT.PlayerState.ENDED) {
        this.isPlaying = false;
        this.classList.remove('active');
      }
    }

    play() {
      if (this.player && typeof this.player.playVideo === 'function') {
        this.player.playVideo();
      }
    }

    pause() {
      if (this.player && typeof this.player.pauseVideo === 'function') {
        this.player.pauseVideo();
      }
    }
  }
  customElements.define('wlsn-youtube-video', WLSNYouTubeVideo);
} 